import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { APP_BROWSER_TITLE } from '@core/constant/app-branding.constants';

/**
 * Sets `document.title` from each route's `title` and appends {@link APP_BROWSER_TITLE}.
 */
@Injectable()
export class AppPageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    if (pageTitle) {
      this.title.setTitle(`${pageTitle} | ${APP_BROWSER_TITLE}`);
    } else {
      this.title.setTitle(APP_BROWSER_TITLE);
    }
  }
}
